// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  enforceHttps: false,
  // apiRoute: 'https://192.168.8.104:5001/',
  apiRoute: 'https://boma-api-staging.azurewebsites.net/',
  //apiRoute: 'http://127.0.0.1:43089/',
  contentRoute: 'https://staging-static-boma.azureedge.net/',
  supplierRoute: 'https://portal.boma.today/',
  adminRoute: 'https://admin.boma.today/',
  websiteRoute: 'https://www.boma.today/',
  apiVersion: '1.0',
  firebaseConfig: {
    apiKey: 'AIzaSyDd4Seep-sZI7lZAZqzLTjoJm5zslv76go',
    authDomain: 'boma-4695e.firebaseapp.com',
    projectId: 'boma-4695e',
    storageBucket: 'boma-4695e.appspot.com',
    messagingSenderId: '274558524244',
    appId: '1:274558524244:web:544ba8322fce09baa986c1',
    measurementId: 'G-M7KXX6XY6K',
  },
  authentication: {
    issuer: 'https://auth-staging.boma.today/',
    clientId: 'staging-supplier-portal',
    scopes: 'openid offline_access api',
  },
  sageConfig: {
    apiKey: '{96485236-9F10-467C-BE21-A5E4B8285FB0}',
    url: 'https://resellers.accounting.sageone.co.za/api/2.0.0',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
